<template>
  <div class="SmartCurtainWidget lxn-w100 lxn-h100" :class="disabledClass">
    <div style="height: 15px;" class="lxn-w100">
    </div>
    <div v-if="curtainType == 0" @click="runScene('up')" class="SmartCurtainWidget-button lxn-margin-auto lxn-circle lxn-float-left lxn-cursor-pointer">
      <ButtonIcon :size="40" bgColor="#f0ebe8" icon="up" iconColor="#51616e" :padding="4" :isRound="false" :borderColor="widgetColor" :borderWidth="4" :onclickEffect="true" />
    </div>
    <div v-if="curtainType == 1" @click="runScene('left')" class="SmartCurtainWidget-button lxn-margin-auto lxn-circle lxn-float-left lxn-cursor-pointer">
      <ButtonIcon :size="40" bgColor="#f0ebe8" icon="arrowLeft" iconColor="#51616e" :padding="4" :isRound="false" :borderColor="widgetColor" :borderWidth="4" :onclickEffect="true" />
    </div>
    <div @click="runScene('stop')" class="SmartCurtainWidget-button lxn-margin-auto lxn-circle lxn-float-left lxn-cursor-pointer">
      <ButtonIcon :size="40" bgColor="#f0ebe8" icon="stop" iconColor="#51616e" :padding="8" :isRound="false" :borderColor="widgetColor" :borderWidth="4" :onclickEffect="true" />
    </div>
    <div v-if="curtainType == 0" @click="runScene('down')" class="SmartCurtainWidget-button lxn-margin-auto lxn-circle lxn-float-left lxn-cursor-pointer">
      <ButtonIcon :size="40" bgColor="#f0ebe8" icon="down" iconColor="#51616e" :padding="4" :isRound="false" :borderColor="widgetColor" :borderWidth="4" :onclickEffect="true" />
    </div>
    <div v-if="curtainType == 1" @click="runScene('right')" class="SmartCurtainWidget-button lxn-margin-auto lxn-circle lxn-float-left lxn-cursor-pointer">
      <ButtonIcon :size="40" bgColor="#f0ebe8" icon="arrowRight" iconColor="#51616e" :padding="4" :isRound="false" :borderColor="widgetColor" :borderWidth="4" :onclickEffect="true" />
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'SmartCurtainWidget',
  props: {
    index: Number
  },
  components: {
    ButtonIcon,
  },
  data: function () {
    return {
      switchLocked: false,
    }
  },
  mounted: function () {
  },
  computed: {
    widget: function () {
      if(this.index != -1){
        return this.$store.state.widgets[this.index];
      }else{
        return null;
      }
    },
    curtainType: function () {
      if(this.index != -1){
        return this.widget.settings.curtainType;
      }else{
        return 0;
      }
    },
    widgetColor: function () {
      if(this.index != -1){
        return this.$store.state.themeMainColors[this.widget.color];
      }else{
        return this.$store.state.themeMainColors[2];
      }
    },
    isHubOffline: function () {
      var isHubOffline = false;
      if(this.index != -1){
        var hub = this.$store.getters.getHubByUUID(this.widget.hubUUID);
        if(hub.connectionStatus.local != 2 && hub.connectionStatus.online != 2){
          isHubOffline = true;
        }
      }
      return isHubOffline;
    },
    disabledClass: function () {
      if(this.index != -1){
        if(this.isHubOffline){
          return "disabled";
        }else{
          return "";
        }
      }else{
        return "";
      }
    },
  },
  methods: {
    generateNodeActions: function (nodeActions) {
      var generatedNodeActions = [];
      var typeOfAction = 0;
      var valueOfChange = 0;

      for(var i = 0; i < nodeActions.length; i++){
        var isNodeNew = true;
        if(nodeActions[i].outputType != "IrDevice" && nodeActions[i].outputType != "RfDevice"){
          if(nodeActions[i].state == 'on'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 1;
          }else if(nodeActions[i].state == 'off'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 0;
          }
        }else if(nodeActions[i].outputType == "IrDevice"){
          var deviceType = nodeActions[i].outputSettings.deviceType;
          var brand = nodeActions[i].outputSettings.brand;
          var model = nodeActions[i].outputSettings.model;
          var irDevice = NODE7.devices[deviceType].brands[brand].devices[model];

          valueOfChange = messaging.utility.arrayTo128(irDevice.commands[nodeActions[i].state.targetCommandIndex].command);
          typeOfAction = CONFIGS.ACTION_TYPE_SET;
        }else if(nodeActions[i].outputType == "RfDevice"){
          valueOfChange = messaging.utility.arrayTo64(nodeActions[i].state.rfCommand);
          typeOfAction = CONFIGS.ACTION_TYPE_SET;
        }
        var action = {
          parameterId: nodeActions[i].parameterId,
          valueOfChange: valueOfChange,
          typeOfAction: typeOfAction,
          timeDelay: nodeActions[i].timeDelay,
        }

        for(var j = 0; j < generatedNodeActions.length; j++){
          if(generatedNodeActions[j].nodeUUID == nodeActions[i].nodeUUID){
            generatedNodeActions[j].actions.push(action);
            isNodeNew = false;
            break;
          }
        }
        if(isNodeNew){
          generatedNodeActions.push(
            {
              nodeUUID: nodeActions[i].nodeUUID,
              actions: [action]
            }
          );
        }
      }
      return generatedNodeActions;
    },
    calculateCommandLength: function (nodeActions, hub) {
      var commandToSend = [];
      var messagingHook = new Messaging(new Logger(false));
      var psk = hub.psk;
      var destinationUUID = hub.uuid;

      messagingHook.init({
        psk: psk,
        destinationUUID: destinationUUID,
        sourceUUID: this.$store.state.user.uuid
      });

      messagingHook.setParametersOfNodesSerializer(commandToSend, {nodeActions: nodeActions});
      return commandToSend.length;
    },
    sendCommand (nodeActions, hub) {
      return new Promise( (resolve) => {
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: hub.psk,
          destinationUUID: hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        console.log(JSON.stringify(nodeActions));
        this.$store.dispatch('setNodesParameters', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          bodyContent: {
            nodeActions: nodeActions,
          }
        })
        .then( () => {
          resolve();
        })
        .catch( response => {
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
          //TODO: should I reject?!
          // reject(hub.UUID);
          resolve();
        });
      })
    },
    delay (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    async runScene(direction) {
      if(this.index != -1){
        if(!this.switchLocked){
          this.$store.commit('setAppBusy', true);
          this.switchLocked = true;
          var rfCommand = [];

          if(direction == 'up'){
            rfCommand = this.widget.settings.curtainUpCommand;
          }else if(direction == 'down'){
            rfCommand = this.widget.settings.curtainDownCommand;
          }else if(direction == 'left'){
            rfCommand = this.widget.settings.curtainLeftCommand;
          }else if(direction == 'right'){
            rfCommand = this.widget.settings.curtainRightCommand;
          }else if(direction == 'stop'){
            rfCommand = this.widget.settings.curtainStopCommand;
          }

          console.log('running scene');
          var hub = this.$store.getters.getHubByUUID(this.widget.hubUUID);
          this.$store.commit('setHubStatus', {
            hubIndex: hub.index,
            stateUpdateEnabled: false,
          });
          var commandPool = rfCommand[0].actions.slice();
          var nodeActions = [];

          do {
            nodeActions.push(commandPool.shift());
            var generatedNodeActions = this.generateNodeActions(nodeActions);
            var commandLength = this.calculateCommandLength(generatedNodeActions, hub);
            if(commandLength > CONFIGS.MAX_LORA_PACKET_SIZE){
              commandPool.unshift(nodeActions.pop());
              generatedNodeActions = this.generateNodeActions(nodeActions);
              await this.sendCommand(generatedNodeActions, hub);
              nodeActions = [];
              // console.log("sent the big command");
            }
            if(commandPool.length == 0){
              generatedNodeActions = this.generateNodeActions(nodeActions);
              // console.log("sending smaller packet");
              await this.sendCommand(generatedNodeActions, hub);
              // console.log("sent smaller packet");
            }
          }
          while(commandPool.length != 0);
          this.$store.commit('setHubStatus', {
            hubIndex: hub.index,
            stateUpdateEnabled: true,
          });
          console.log("DONE!!!");
          this.switchLocked = false;
          this.isButtonActive = false;
          this.$store.commit('setAppBusy', false);
        }
      }
    },
  },
}
</script>

<style>
  .SmartCurtainWidget.disabled {
    opacity: 0.5;
  }
  .SmartCurtainWidget-button  {
    margin-left: calc(25% - 30px);
  }
</style>
